// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-m__title__n2utv","text":"styles-m__text__6wzdz"};